// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar--+kX-B","avatarCount":"avatarCount--wGLg2"};